import {ReactElement} from "react";
import {StyledBoxColumn} from "../../shared/StyledComponents";
import {Page} from "../types";
import {Typography} from "@mui/material";
import {StoredDataFileUploadFragment} from "../../shared/StoredDateFileUploadFragment";
import {DIVIDER} from "../../shared/dimens";

export default function PracticePageVerificationIdentity({page, value, setValue}: {
  page: Page,
  value: string,
  setValue: (url: string) => void
}): ReactElement {
  return <StyledBoxColumn>
    <Typography variant="h6">{page.practicePageProfile.basicInfo.name}</Typography>
    <StoredDataFileUploadFragment
      style={{border: DIVIDER}}
      mimeTypes={["image/*"]}
      storedDataSource={"practice-page-verifications"}
      initialUrls={value ? [value] : undefined}
      onUploadDone={(urls: string[]) => {
        setValue(urls[0]);
      }}/>
    <Typography variant={"body2"}>
      Please upload your ownership proof of your practice.
      <br/>
      <br/>
      Acceptable documents:
      <ul>
        <li>Clinic registration</li>
        <li>Municipality document for waste disposal</li>
        <li>Sales tax receipt for the business</li>
        <li>Clinic sign board</li>
      </ul>
    </Typography>
  </StyledBoxColumn>
}

export function renderPracticePageVerificationIdentity(page: Page, value: string, setValue: (url: string) => void): ReactElement {
  return <PracticePageVerificationIdentity page={page} value={value} setValue={setValue}/>;
}